/* global moment */

import { formatter } from '@lib/formatter';

const initGlobal = () => {
    /*
        correct NL locales for formatting in moment to match strftime
    */
    formatter.patchLocales(moment);
};

export default initGlobal;
